<!--
 * @Author: 仙道
 * @Date: 2022-04-23 17:31:04
 * @LastEditTime: 2022-05-12 16:37:44
 * @email: hao.li08@weimob.com
 * @Description: 设备手册
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/form/AccountManual.vue
-->
<template>
  <!-- <a-table :columns="tableColumns" :dataSource="propsData" :pagination="false">
      <template slot="status" slot-scope="status">
        <a-badge :status="status | statusTypeFilter" :text="status | statusFilter" />
      </template>
  </a-table>-->
  <DevDocList />
</template>

<script>
  import DevDocList from '../../vue/DevDocsList'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AccountManual',
    props: {
      propsData: {
        type: Array,
        default: () => []
      }
    },
    components: {
      DevDocList
    },
    // 定义属性
    data () {
      return {
        tableColumns: [
          {
            title: '手册名称',
            dataIndex: 'type',
            key: 'type'
          },
          {
            title: '说明',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '上传人员',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '上传日期',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '文档格式',
            dataIndex: 'type',
            key: 'type'
          }, {
            title: '操作',
            dataIndex: 'type',
            key: 'type'
          }
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
